import {Schemas} from "./../schemas";

export default class QueryBuilderService {

    public dropTable(tableName: string) {
        return `DROP TABLE IF EXISTS ${tableName}`;
    }

    public createTable(tableName: string) {
        let fkcolumn = [] as any;
        let columnQuery: (string | number | null)[] = Schemas[tableName].map((column: any) => {
            (column['foreignKey'] !== undefined) && fkcolumn.push(`, FOREIGN KEY (${column['name']}) REFERENCES ${column['foreignKey']['referenceTable']} (${column['foreignKey']['referenceKey']})`);
            return column['name'] + ' ' +
                (column['type'] === 'boolean' ? 'integer' : column['type']) +
                (column['isPrimary'] !== undefined ? ' primary key' : '') +
                (column['defaultValue'] !== undefined ? (' default ' + column['defaultValue']) : '');
        });
        return `CREATE TABLE IF NOT EXISTS ${tableName} (${columnQuery.join(", ")}${fkcolumn.join(" ")})`;
    }

    public insert(tableName: string, data: any[]) {
        if (!(Schemas[tableName] && Schemas[tableName].length && data && data.length)) {
            return { query: 'SELECT 1', params: [] };
        }

        const columns = Schemas[tableName].map((column: any) => column.name);
        const params: any[] = [];

        let insertQueries: string[] = data.map(row => {
            let queryData: string[] = columns.map((column: string) => {
                if (typeof row[column] === "boolean") {
                    params.push(row[column] ? 1 : 0);
                    return '?';
                }
                if (row[column] !== undefined && row[column] !== null && row[column] !== '') {
                    params.push(row[column]);
                    return '?';
                }
                return 'null';
            });
            return `( ${queryData.join(", ")} )`;
        });

        const query = `INSERT INTO ${tableName} ( ${columns.join(", ")} ) VALUES ${insertQueries.join(", ")}`;
        return { query, params };
    }

    public insertOrReplace(tableName: string, data: any[]) {
        if (!(Schemas[tableName] && Schemas[tableName].length && data && data.length)) {
            return { query: 'SELECT 1', params: [] };
        }

        const columns = Schemas[tableName].map((column: any) => column.name);
        const params: any[] = [];

        const insertQueries: string[] = data.map(row => {
            const queryData: string[] = columns.map((column: string) => {
                if (typeof row[column] === "boolean") {
                    params.push(row[column] ? 1 : 0);
                    return '?';
                }
                if (row[column] !== undefined && row[column] !== null && row[column] !== '') {
                    params.push(row[column]);
                    return '?';
                }
                return 'null';
            });
            return `( ${queryData.join(", ")} )`;
        });

        const query = `INSERT OR REPLACE INTO ${tableName} ( ${columns.join(", ")} ) VALUES ${insertQueries.join(", ")}`;
        return { query, params };
    }

    public select(tableName: string, columns: string[] = [], where: { name: string, value: string | number, operator?: string }[] = [], orderBy: { name: string, value?: string }[] = []) {
        const whereResult = this.whereCondition(where);
        const query = `SELECT ${columns.length ? columns.join(', ') : '*'} FROM ${tableName} ${whereResult.query} ${this.orderBy(orderBy)}`.trim();
        return { query, params: whereResult.params };
    }

    public truncate(tableName: string) {
        return { query: `DELETE FROM ${tableName}`, params: [] as any[] };
    }

    public update(tableName: string, data: any, where: { name: string, value: string | number, operator?: string }[] = []) {
        if (!(Schemas[tableName] && Schemas[tableName].length && data)) {
            return { query: '', params: [] };
        }

        const columns = Schemas[tableName].map((column: any) => column.name);
        let updateQuery: string[] = [];
        let params: any[] = [];

        Object.entries(data).forEach(value => {
            if (columns.includes(value[0])) {
                updateQuery.push(`${value[0]} = ?`);
                params.push(typeof value[1] === "boolean" ? (value[1] ? 1 : 0) : value[1]);
            }
        });

        const whereResult = this.whereCondition(where);
        params.push(...whereResult.params);

        const query = `UPDATE ${tableName} SET ${updateQuery.join(", ")} ${whereResult.query}`.trim();
        return { query, params };
    }

    public whereCondition(where: { name: string, value: string | number, operator?: string }[]) {
        let query = '';
        let params: any[] = [];
        if (where.length > 0) {
            where.forEach(function (condition, key) {
                query += (key === 0 ? ' WHERE ' : ' AND ') + condition.name + (" " + (condition.operator !== undefined ? condition.operator : '=') + " ?");
                params.push(condition.value);
            });
        }
        return { query, params };
    }

    public orderBy(orderBy: { name: string, value?: string }[]) {
        let query = '';
        if (orderBy.length > 0) {
            orderBy.map(function (column, key) {
                return query += `${(key === 0 ? 'ORDER BY' : ',')} ${column.name} ${column.value === 'DESC' ? 'DESC' : 'ASC'}`;
            });
        }
        return query;
    }

    public delete(tableName: string, where: { name: string, value: string | number, operator?: string }[] = []) {
        const whereResult = this.whereCondition(where);
        return { query: `DELETE FROM ${tableName} ${whereResult.query}`.trim(), params: whereResult.params };
    }

    public deleteIn(tableName: string, name: string, paramsList: string[] = []) {
        const placeholders = paramsList.map(() => '?').join(',');
        return { query: `DELETE FROM ${tableName} WHERE ${name} IN (${placeholders})`, params: paramsList };
    }

    public selectIn(tableName: string, name: string, paramsList: (string | number)[] = []) {
        if (!paramsList.length) {
            return { query: `SELECT * FROM ${tableName} WHERE 1=0`, params: [] };
        }
        const placeholders = paramsList.map(() => '?').join(',');
        return { query: `SELECT * FROM ${tableName} WHERE ${name} IN (${placeholders})`, params: paramsList };
    }

    public getSingleResult(result: any) {
        if (result && result.rows && result.rows.length) {
            return result.rows.item(0);
        }
        return {};
    }

    public getAllResult(result: any) {
        const data: any[] = [];
        if (result && result.rows && result.rows.length) {
            for (let i = 0; i < result.rows.length; i++) {
                data.push(result.rows.item(i));
            }
        }
        return data;
    }
}
